import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router';
import { isType } from '@/utils/public';
import env from '../../default.config'

// post重复请求开关
let repFlag = true;
axios.defaults.baseURL = env._BaseUrl;
axios.defaults.timeout = 10000;
axios.defaults.headers.post['Content-Type'] = 'application/json'
// 请求拦截器
axios.interceptors.request.use(config => {
    repFlag = false;
    const token = sessionStorage.token
    token && (config.headers.JwtToken = token)
    return config
}, error => {
    return Promise.error(error)
})

// 响应拦截器
axios.interceptors.response.use(response => {
    repFlag = true;
    if (response.status === 200) {
        if (isType(response.data) !== 'Object' && response.data) {
            return Promise.resolve(response);
        }
        switch (response.data.code) {
            case 401: // 清除token信息，并返回登录页面
                sessionStorage.token = "";
                // store.commit('logout');
                router.replace({
                    path: '/login',
                    query: {
                        redirect: router.currentRoute.fullPath
                    }
                });
                break;
            case 0:
                return Promise.resolve(response);
            default:
                Message.closeAll();
                Message({
                    message: response.data.msg,
                    type: 'error',
                    duration: 3 * 1000
                })
                return Promise.reject(response);
        }
    } else {
        return Promise.reject(response);
    }
}, error => {
    repFlag = true;
    const msg = error.Message ? error.Message : '';
    // 状态码不是200的情况
    if (error.response && error.response.status) {
        switch (error.response.status) {
            case 401:
                store.commit('logout');
                router.replace({
                    path: '/login',
                    query: {
                        redirect: router.currentRoute.fullPath
                    }
                });
                break;
            default:
                break;
        }
        return Promise.reject(error.response)
    }
    Message.closeAll();
    Message({
        message: '系统错误' + msg,
        type: 'error',
        duration: 5 * 1000
    })
})

/**
 * get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export const get = (url, params) => {
    // 接口唯一标识
    let requestId = new Date().getTime() + Math.round(Math.random() * 10000);
    let pubParams = {
        requestId: requestId,
        ...params
    }
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: pubParams
        }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err.data)
        })
    })
}

/**
 * post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export const post = (url, params, obj) => {
     // 接口唯一标识
    let requestId = new Date().getTime() + Math.round(Math.random() * 10000);
    let pubParams = {};
    if(url.indexOf('datacenter')!=-1){
    let type = JSON.parse(sessionStorage.getItem("userInfo")).type;
    if (type === 0) {
        pubParams = {
            copyrightId: JSON.parse(sessionStorage.getItem("userInfo")).id,
            copyrightMerchantId: JSON.parse(sessionStorage.getItem("userInfo")).merchantId,
        }
    }
    if (type === 1) {
        pubParams = {
            channelMerchantId: JSON.parse(sessionStorage.getItem("userInfo")).merchantId
        }
    }
}
    // pubParams,
    let excludeUrls = [],
        excludeFlag = excludeUrls.includes(url);
    if (repFlag || excludeFlag) {
        return new Promise((resolve, reject) => {
            axios.post(url, {requestId: requestId,...pubParams,...params}, obj).then(res => {
                resolve(res.data.data)
            }).catch(err => {
                reject(err.data)
            })
        })
    } else {
        return new Promise((resolve, reject) => {
            reject('');
        })
    }
}
export default axios;